import React from "react";
import "./maxbeamslideshow.css";

export const Maxbeamslideshow = () => {
	return (
		<div className="maxbeamslideshow">
			<iframe
				loading="lazy"
				className="maxbeamslideshowiframe"
				src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFZ_a8w8gA&#x2F;view?embed"
				allowfullscreen="allowfullscreen"
				allow="fullscreen"
			></iframe>
		</div>
	);
};
